/**
 * ReadTimeChip — compact "N min read" badge for card lists and
 * article headers. Accepts either a pre-computed minute count or
 * raw HTML that it estimates client-side (same 200 wpm formula the
 * backend uses, so the numbers stay consistent).
 */
import { Clock } from "lucide-react";

const WPM = 200;

export function estimateMinutes(html) {
  if (!html) return 0;
  const text = String(html).replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  if (!text) return 0;
  const words = text.split(" ").length;
  return Math.max(1, Math.ceil(words / WPM));
}

export default function ReadTimeChip({
  minutes,
  html,
  className = "",
  variant = "light",
  testId = "read-time-chip",
}) {
  const m = typeof minutes === "number" && minutes > 0 ? minutes : estimateMinutes(html);
  if (!m) return null;
  const styles =
    variant === "dark"
      ? "bg-black/40 text-white backdrop-blur-sm"
      : "bg-slate-100 text-slate-600";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${styles} ${className}`}
      data-testid={testId}
    >
      <Clock className="w-3 h-3 opacity-70" />
      {m} min read
    </span>
  );
}
